module.exports = __webpack_public_path__ + "img/2-424-424-01.046be498.png";